  <div class="container-custom">
    <div class="row align-items-center justify-content-center">

      <form #form="ngForm" (ngSubmit)="onSubmit(form)" autocomplete="off" novalidate>
        <div class="card" style="width: 21rem;">
          <div class="card-header">{{'CPASS.PASSWORD_CHANGE' | translate}}</div>
          <div class="card-body">

            <div class="row">
              <div class="col-md-12">
                <label [innerHTML]="'CPASS.OLD_PASSWORD'| translate"></label>
                <input type="password" autocomplete="new-password" name="oldPassword" [(ngModel)]="requestChangePassword.oldPassword" class="form-control w-100" id="oldPassword" required #oldPassword="ngModel">
                <div class="spacer-custom-100"></div>
              </div>

              <div class="col-md-12">
                <label [innerHTML]="'CPASS.NEW_PASSWORD'| translate"></label>
                <input type="password" autocomplete="new-password" name="newPassword1" [(ngModel)]="requestChangePassword.newPassword1" class="form-control w-100" id="newPassword1" required #newPassword1="ngModel">
                <div class="spacer-custom-100"></div>
              </div>


              <div class="col-md-12">
                <label [innerHTML]="'CPASS.CONFIRM_NEW_PASSWORD'| translate"></label>
                <input [class.is-invalid]="(requestChangePassword.newPassword1 != requestChangePassword.newPassword2 && newPassword2.dirty)"
                       type="password" autocomplete="new-password" name="newPassword2" [(ngModel)]="requestChangePassword.newPassword2"
                       class="form-control w-100" id="newPassword2" required #newPassword2="ngModel">
                <small class="text-danger" [class.d-none]="!(requestChangePassword.newPassword1 != requestChangePassword.newPassword2 && newPassword2.dirty)">{{'CPASS.PASS_NOT_MATCH' | translate}}</small>
              </div>

            </div>
            <input type="hidden" name="logUser" [(ngModel)]="requestChangePassword.logUser" class="form-control" id="logUser" #logUser="ngModel">

            <div class="spacer-custom-100"></div>
            <div class="spacer-line-custom"></div>
            <div class="spacer-custom-100"></div>
            <div class="spacer-custom-100"></div>
            <div class="spacer-custom-100"></div>

            <div class="text-center">
                <button class="btn btn-custom" style="min-width: 100px" type="submit" [disabled]="form.invalid || requestChangePassword.newPassword1 != requestChangePassword.newPassword2">{{'CPASS.SAVE' | translate}}</button>&nbsp;
                <button class="btn btn-outline-custom" type="button" (click)="resetForm(form)">{{'CPASS.CANCEL' | translate}}</button>
            </div>

          </div>
          </div>
      </form>
    </div>
 </div>

